import useQuery from './useQuery'

const shortId = id => (id ? String(id).split('/').pop() : id)

/**
 * Series de crecimiento + curvas de referencia OMS del paciente, en un solo
 * request (el cálculo LMS vive en el server — ver api/src/percentiles).
 * Mismo criterio que el resto de las betas: `enabled` gatea el fetch (el
 * modal es lazy y la query solo corre con el modal abierto), retry corto.
 *
 * `correctedAge` (punto 3, "edad corregida para prematuros"): va embebido
 * en el string del endpoint a propósito — hooks/useQuery.js arma la query
 * key de react-query como [endpoint, ...] (endpoint COMPLETO, con query
 * string incluido), así que togglear esto entre true/false ya alcanza para
 * que react-query lo trate como una key distinta y dispare el refetch solo,
 * sin necesitar un `growth.refetch()` manual.
 */
export const useGrowth = (consumerID, enabled, correctedAge) =>
  useQuery(window._l(`/percentiles/growth/${shortId(consumerID)}${correctedAge ? '?correctedAge=1' : ''}`).substr(1), {
    enabled: !!(consumerID && enabled),
    staleTime: 30000,
    retry: false,
  })

export default useGrowth
